import styled from 'styled-components';
import { colors } from '../../colors';

interface IContainerProps {
  isValid: boolean;
}
interface IIconProps {
  enabled?: boolean;
}
export const StyledIncrementalInput = styled.button<IContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 6px 16px;
  border: 1px solid ${(props) => (props.isValid ? colors.grey30 : colors.red30)};
  border-radius: 12px;
  min-width: 146px;

  background-color: white;
  :focus-within {
    border-color: ${(props) => props.isValid && colors.grey90};
  }
`;
export const Counter = styled.input`
  border: none;
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -moz-appearance: textfield;
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  color: ${colors.black};
  font-family: 'DM Sans';
  &:focus {
    outline: none;
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
export const Icon = styled.img<IIconProps>`
  height: 16px;
  width: 16px;
  object-fit: contain;
  cursor: pointer;
  filter: brightness(0%);
  opacity: ${(props) => (props.enabled ? 1 : 0.3)};
`;
